import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import ApiResponse from "sr/models/ApiResponse";
import { post } from "sr/utils/axios";

export const createContractor = async (postData) => {
    try {
  return await post<ApiResponse<[]>>('/contractor', postData).then((res)=> {
        if(res.success===true) {
            return res
        }
        else {
                HandleApiError(res.error.msg)
        }
    }) }
    catch(e) {
         HandleApiError(e)   
    }

};
